import { useRecordContext, Button, useNotify } from "react-admin";
import { useCallback, useState } from "react";
import { CircularProgress } from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { RankingStatus, RankingType } from "utils/constants";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import AdditionalCapacityDialog from "./AdditionalCapacityDialog";

const REINSTATING_RIGHTS_ID = 0;

const isWithinEnrollmentPeriod = (from, to) => {
  const now = Date.now();
  const start = from ? new Date(from).getTime() : null;
  const end = to ? new Date(to).getTime() : null;

  if (start && now < start) return false;
  if (end && now > end) return false;

  return true;
};

const AdditionalCapacityButton = () => {
  const record = useRecordContext();
  const notify = useNotify();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [specialityIds, setSpecialityIds] = useState([]);
  const rankingId = record?.id;

  const handleOpen = useCallback(async () => {
    setLoading(true);
    try {
      const local = record?.specialityIds ?? record?.specialityRankings?.map(x => x.specialityId);
      let ids = local;

      if (!ids?.length) {
        const { data } = await dataProvider.customRequest(candidateRequests.campaignRanking(rankingId), null, "GET");
        ids = data?.specialityIds;
      }

      setSpecialityIds((ids ?? []).filter(id => id !== REINSTATING_RIGHTS_ID));
      setOpen(true);
    } catch {
      notify("Неуспешно зареждане на специалностите за класирането. Опитайте да презаредите страницата.", {
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  }, [record, rankingId, notify]);

  if (!record) {
    return null;
  }

  const isApproved = record.status === RankingStatus.Approved;
  const isSupportedType = record.type !== RankingType.HospitalContract;
  const isInEnrollmentPeriod = isWithinEnrollmentPeriod(record.enrollmentStartDate, record.enrollmentEndDate);

  if (!isApproved || !isSupportedType || !isInEnrollmentPeriod) {
    return null;
  }

  return (
    <SecuredComponent permission={permissions.canAddCandidateCampaignRankingAdditionalCapacity}>
      <>
        <Button
          label="Допълнителни места"
          onClick={handleOpen}
          variant="contained"
          size="medium"
          disabled={loading}
          sx={{ whiteSpace: "nowrap" }}
        >
          {loading ? <CircularProgress size={20} /> : <GroupAddIcon />}
        </Button>
        <AdditionalCapacityDialog
          open={open}
          onClose={() => setOpen(false)}
          rankingId={rankingId}
          specialityIds={specialityIds}
          isState={record.type === RankingType.State}
        />
      </>
    </SecuredComponent>
  );
};

export default AdditionalCapacityButton;
